import { MenuItem } from '@mui/material';
import UseAuthContext from 'context/AuthContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { USER_ROLES } from 'utils/constants';
import { AdminMenus, InspectorMenus, InspectorPublicMenus, PrivateMenus, PublicMenus } from 'utils/utils';

const HeaderMenu = ({ isForHeader, isRowDirection = false, onClose = () => {} }: any) => {
  const { isAuthenticated, role } = React.useContext(UseAuthContext);
  const { t } = useTranslation();
  const location = useLocation();
  const isAdminRole = role && role.toLowerCase() === USER_ROLES.ADMIN;
  const isContactPage = location.pathname === '/contact' ;
  const isSignUpByInvitePage = location.pathname === '/signupbyinvite' ;
  const isSignUpPage = location.pathname === '/signup' ;
  const isPricingPage = location.pathname === '/pricing' ;
  const isInspectorRole = role === USER_ROLES.INSPECTOR || role === USER_ROLES.INSPECTOR_MANAGER;
  const isViewerRole = role === USER_ROLES.VIEWER;
  const BindMenus = () => {
    let menus: any;
    
    if (role && role.toLowerCase() === USER_ROLES.ADMIN) {
      menus = [...AdminMenus];
    } else if (role && role.toLowerCase() === USER_ROLES.INSPECTOR || role && role.toLowerCase() === USER_ROLES.INSPECTOR_MANAGER) {
      menus = [...InspectorMenus, ...InspectorPublicMenus];
    } else if (isAuthenticated) {
      menus = [...PrivateMenus, ...PublicMenus];
    } else {
      menus = [...PublicMenus];
    }

    if (isForHeader) {
      menus = menus.sort((a: any, b: any) => a.order - b.order);
      menus = menus.filter((menu: any) => !menu.removeFromHeader);
      if (isContactPage && !isAuthenticated ||isSignUpPage ||isSignUpByInvitePage || isPricingPage && !isAuthenticated) {
        menus = menus.filter((menu: any) => menu.name !== 'MENU_CONTACT' && menu.name == '"MENU_HOW_IT_WORKS"' );
      } 
    } else {
      menus = PublicMenus.sort(
        (a: any, b: any) => a.footerOrder - b.footerOrder
      );
      if (isContactPage && !isAuthenticated || isPricingPage && !isAuthenticated) {
        menus = menus.filter((menu: any) => menu.name !== 'MENU_HOW_IT_WORKS');
      }
      if (isAdminRole) {
        menus = menus.filter((menu: any) => menu.name !== 'MENU_CONTACT' && menu.name !== 'MENU_PRICING' && menu.name !== 'MENU_HOW_IT_WORKS');
      }
      if(!isAuthenticated){
        menus= menus.filter((menu: any) => menu.name !== 'MENU_PRICING' && menu.name !== 'TERMS_OF_USE');
      }
      if(isInspectorRole){
        menus = menus.filter((menu: any) => menu.name !== 'MENU_PRICING' && menu.name !== 'MENU_HOW_IT_WORKS');
      }
      if(isViewerRole){
        menus = menus.filter((menu: any) => menu.name !== 'MENU_PRICING');
      }

    }

    return menus.map((menu: any) => {
      if ((isSignUpPage || isSignUpByInvitePage) && menu.name === 'MENU_HOW_IT_WORKS') {
        return null;
      }

      const handleNavigation = () => {
        if (typeof onClose === 'function') {
          onClose();
        }
      };

      if (isRowDirection) {
        return (
          <MenuItem key={menu.name} style={{ display: 'flex', flexDirection: 'row' }}>
            {menu.external ? (
              <a href={menu.path} target='_blank' rel='noreferrer' onClick={handleNavigation}>
                {t(menu.name)}
              </a>
            ) : (
              <Link to={menu.path} onClick={handleNavigation}>
                {t(menu.name)}
              </Link>
            )}
          </MenuItem>
        );
      }

      return menu.external ? 
      
      (
        <a href={menu.path} key={menu.name} target='_blank' rel='noreferrer' onClick={handleNavigation}>
          {t(menu.name)}
        </a>
      ) : (
        <Link to={menu.path} key={menu.name} onClick={handleNavigation}>
          {t(menu.name)}
        </Link>
      );
    }).filter(Boolean);
  };
  return <>{BindMenus()}</>;
};

export default HeaderMenu;
